import { useTranslate } from "@similarweb/i18n-provider";
import { Warning } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { Button } from "@similarweb/ui-components";

import { StateContainer } from "./StateContainer";

interface IFeedErrorStateProps {
    resetErrorBoundary: () => void;
}

export const FeedErrorState = ({ resetErrorBoundary }: IFeedErrorStateProps) => {
    const { translate } = useTranslate();

    return (
        <StateContainer
            title={translate("activation.alerts.feed.error.title")}
            subtitle={translate("activation.alerts.feed.error.subtitle")}
        >
            <Warning
                width={80}
                height={80}
                color={colorsPalettes.carbon[250]}
            />
            <Button
                type="flat"
                onClick={resetErrorBoundary}
            >
                {translate("activation.alerts.feed.error.retry")}
            </Button>
        </StateContainer>
    );
};
